export const GOOGLE_CONSENT_LOCAL_STORAGE_ID = 'googleApiConsent';
